<template>
  <div
      class="custom-breadcrumbs txt-detail flex-center-col"
      :style="{
        'left': $vuetify.breakpoint.mdAndDown ? '0' : '256px',
        'padding': $vuetify.breakpoint.mdAndDown ? '10px 16px' : '10px 64px'
      }"
  >
    <!-- {{ mainPage }} -->
    <div v-if="breadcrumb" class="d-flex align-center">
      <div v-for="(item, i) in breadcrumb.breadCrumbs" :key="i">
        <span
          :style="
            i == 0 && breadcrumb.breadCrumbs.length > 1
              ? { color: '#637381' }
              : { color: '#212B36' }
          "
        >
          <a
            class="breadcrumb-link"
            v-if="item.route"
            :href="mainSite + (customBreadcrumb[i] ? customBreadcrumb[i].route : item.route)"
          >
            {{ customBreadcrumb[i] ? customBreadcrumb[i].name : item.name }}
          </a>
          <span v-else>{{ customBreadcrumb[i] ? customBreadcrumb[i].name : item.name }}</span>
        </span>
        <v-icon
          color="#919EAB"
          v-if="i < breadcrumb.breadCrumbs.length - 1"
          class="mx-0"
        >
          mdi-chevron-right
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mainPage, breadCrumbs, mainSite } from "@/store/constants"
import { eventBus } from "../plugins/global-funcs"

export default {
  name: "MenuBreadcrumb",
  data() {
    return {
      // mainPage,
      mainSite,
      customBreadcrumb: {}
    };
  },
  computed: {
    breadcrumb() {
      var bc = "";
      bc = breadCrumbs.find((item) => item.mainPage === mainPage);
      return bc;
    },
  },
  created() {
    eventBus.$on('customBreadcrumbTitle', ({ name = '', route = '', bcIndex = 0 }) => {
      this.customBreadcrumb[bcIndex] = { name, route }
      this.$forceUpdate()
    })
  }
};
</script>

<style scoped>
.custom-breadcrumbs {
  border-bottom: 1px solid #e5e8eb;
  background: #fff;
  height: var(--breadcrumb-height);
  position: fixed;
  right: 0;
  z-index: 10;
}
.breadcrumb-link {
  color: #212b36;
  text-decoration: none;
}
</style>
